import Api from 'api/api';

class UserApi {
    getMe() {
        return Api.get('/users/me');
    }
}

export default new UserApi();


// WEBPACK FOOTER //
// ./src/api/user.js